<template>
  <div class="grow flex flex-col">
    <slot class="flex-none" name="selected" :component="component" />

    <div class="pbc-links grow overflow-auto">
      <div class="pbc-link grow overflow-scroll" v-for='{name, components} in linkGroups' :key='name'>
        <div class="pbc-link-name">{{name}}</div>
        <div class="pbc-link-components" v-for='component in components' :key='component.id'>
          <slot name="from" :component='component' :has-slots='hasSlots(component)' />
        </div>
      </div>
      <slot name="after" :component="component" />
    </div>

    <div class="flex-none" v-for='{component} in toComponents' :key='component.id'>
      <slot name="to" :component='component' />
    </div>

  </div>
</template>
<script>
import SelectedComponentMixin from '@components/selectedComponentMixin.js';
export default {
  mixins: [SelectedComponentMixin],
}
</script>
